<template>
	<div class="video-processing" :class="{ 'video-processing--compact-landscape': compactLandscape }" role="status">
		<div class="icon">
			<img :src="processingIllustration" alt="Processing" />
		</div>
		<h5 class="message">This video is still processing...</h5>
		<div v-if="refreshable" class="refresh d-flex">
			<v-btn rounded="pill" variant="flat" :loading="refreshing" :disabled="refreshing" @click="emit('refresh')">
				<v-icon>icon-refresh</v-icon>Refresh
			</v-btn>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { computed } from "vue";
	import { useDisplay } from "vuetify";
	import { VBtn, VIcon } from "vuetify/lib/components/index.mjs";
	import processingIllustration from "../assets/liveswitch-v-sign-hand-emoji.svg";

	defineProps<{ refreshable?: boolean; refreshing?: boolean }>();
	const emit = defineEmits<{ refresh: [] }>();
	const display = useDisplay();
	const compactLandscape = computed(() => display.smAndDown.value && display.width.value > display.height.value);
</script>

<style scoped>
	.video-processing {
		display: flex;
		width: 100%;
		height: 100%;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		border-radius: 0.75rem 0 0 0;
		border: 2px solid var(--ls-contact-theme-space-cadet-8, rgba(3, 1, 29, 0.08));
		background: var(
			--Video-Processing-Gradient,
			linear-gradient(254deg, #f7f5fe 0%, #f0f8ff 13.76%, #ebfffa 43.55%, #eaf9ff 76.6%, #fef5fd 99.13%)
		);
	}
	.message {
		margin: 1rem 0;
	}
	/* Admin's button typography, explicit so the async gallery (Vuetify's default casing) renders it too. */
	.refresh > .v-btn {
		background: #03011d80;
		color: #fff;
		font-weight: 600;
		letter-spacing: normal;
		text-transform: none;
	}
	/* The label sits in .v-btn__content, which async's base.css `*` reset sets to normal weight. */
	.refresh > .v-btn :deep(.v-btn__content) {
		font-weight: inherit;
	}
	.video-processing--compact-landscape {
		display: grid;
		grid-template-columns: auto auto;
		grid-template-rows: auto auto;
		gap: 0.5rem 1rem;
		align-content: center;
	}
	.video-processing--compact-landscape .icon {
		grid-column: 2;
		grid-row: 2;
		justify-self: start;
	}
	.video-processing--compact-landscape .icon img {
		height: 2.25em;
	}
	.video-processing--compact-landscape .message {
		grid-column: 1 / -1;
		grid-row: 1;
		margin: 0.5rem 0;
		font-size: 1.25rem;
	}
	.video-processing--compact-landscape .refresh {
		grid-column: 1;
		grid-row: 2;
		justify-self: end;
	}
</style>
